<template>
<v-dialog v-model="bgSoundFlag" max-width="1280" :fullscreen="isMobile">
  <div v-loading="loading" element-loading-spinner="el-icon-loading">
    <v-card class="bg-sound-container">
      <span class="entypo--cross close-btn" @click="bgSoundFlag = false"></span>
      <v-row class="first-row" no-gutters>
        <v-col style="margin: 2px 4px">
          <v-row no-gutters>
            <v-col style="max-width: 60px;">
              <el-tooltip :content="'播放/停止'" placement="top">
                <div id="control" :class="this.$store.state.isPlayBgSound?'is--playing':''" @click="clickPlay()">
                  <div class="border"></div>
                  <div class="play"></div>
                </div>
              </el-tooltip>
            </v-col>
            <v-col style="max-width: 60px;">
              <el-tooltip :content="'方案管理'" placement="top">
                <span :class="'foldBtn ' + (this.isFold?'line-md--folder-arrow-up':'line-md--folder-arrow-down')" @click="clickFold()"></span></el-tooltip>
            </v-col>
            <v-col style="max-width: 60px;">
              <el-tooltip :content="'定时器'" placement="top">
                <span :class="'timerBtn ' + (this.isCountDown?'svg-spinners--clock':'svg-spinners--clock-stop')" @click="clickTimer()"></span>
              </el-tooltip>
            </v-col>
            <v-col style="position: relative; max-width: 300px;min-width: 120px;">
              <div v-if="!this.isCountDown" class="time-picker-div">
                <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="time" label="定时(时:分)" v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" format="24hr" v-model="time" full-width @click:minute="$refs.menu.save(time);pickTime()"></v-time-picker>
                </v-menu>
              </div>
              <div v-if="this.isCountDown">
                <countdown ref="countdown" :time="transTimeToCountDown(time)" @end="handleCountdownEnd">
                  <template slot-scope="props">
                    <div id="clock">
                      <p class="time">
                        {{ props.hours.toString().padStart(2, '0') }} : {{ props.minutes.toString().padStart(2, '0') }} : {{ props.seconds.toString().padStart(2, '0') }}
                      </p>
                    </div>
                  </template>
                </countdown>
              </div>
            </v-col>
            <v-col class="elShowWhenWeb" style="max-width: 60px;">
              <el-tooltip :content="'过滤选中项'" placement="top">
                <span :class="'filterBtn ' + (this.isFilter?'line-md--filter-plus':'line-md--filter')" @click="clickFilter()"></span>
              </el-tooltip>
            </v-col>
            <v-col class="elShowWhenWeb" style="max-width: 60px;">
              <el-tooltip :content="'重置'" placement="top">
                <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="blue" title="确定重置配置吗？" @confirm="reset()">
                  <span slot="reference" class="resetBtn ri--reset-left-line" @click="emptyMethod()"></span></el-popconfirm>
              </el-tooltip>
            </v-col>
            <v-col class="elShowWhenWeb" style="max-width: 60px;">
              <el-tooltip :content="'全局音量'" placement="top">
                <span :class="'volumeBtn ' + (getVolumeIcon())" @click="clickVolume()"></span>
              </el-tooltip>
            </v-col>
            <v-col class="elShowWhenWeb" style="position: relative; max-width: 300px;min-width: 120px;">
              <v-slider class="volume-slider" v-model="volume" :thumb-size="24" thumb-label @end="updateSliderVolume"></v-slider>
            </v-col>
          </v-row>

          <v-row no-gutters class="elShowWhenMobileFlex">
            <v-col style="max-width: 60px;">
              <el-tooltip :content="'过滤选中项'" placement="top">
                <span :class="'filterBtn ' + (this.isFilter?'line-md--filter-plus':'line-md--filter')" @click="clickFilter()"></span>
              </el-tooltip>
            </v-col>
            <v-col style="max-width: 60px;">
              <span class="resetBtn ri--reset-left-line" @click="reset()"></span>
            </v-col>
            <v-col style="max-width: 60px;">
              <span :class="'volumeBtn ' + (getVolumeIcon())" @click="clickVolume()"></span>
            </v-col>
            <v-col style="position: relative; max-width: 300px;min-width: 120px;">
              <v-slider class="volume-slider" v-model="volume" :thumb-size="24" thumb-label @end="updateSliderVolume"></v-slider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- 收缩框 -->
      <Transition name="fade">
        <v-row class="second-row" v-if="!isFold">
          <v-col style="margin: 4px 4px" :cols="isMobile?12:''">
            <v-card class="mx-auto" v-loading="loadingMySchema" element-loading-spinner="el-icon-loading">
              <v-row class="schemaTitle">
                <h2>我的配置：</h2>
              </v-row>
              <v-row class="mySchema">
                <v-col :cols="7">
                  <v-text-field v-model="newSchemaText" class="addSchemaText" hide-details="auto" label="设置配置名称"></v-text-field>
                </v-col>
                <v-col :cols="2" style="margin-top: 22px;max-width: 60px;">
                  <span class="mySchemaUse" @click="clickAddSchema()">保存</span>
                </v-col>
                <v-col :cols="3">
                </v-col>
              </v-row>
              <v-row class="mySchema" v-for="(item, index) in mySchemaList" :key="index">
                <v-col :cols="7">
                  <p class="mySchemaName">{{item.name}}</p>
                </v-col>
                <v-col :cols="2" style="max-width: 60px;">
                  <span class="mySchemaUse" @click="clickMySchemaUse(item)">使用</span>
                </v-col>
                <v-col :cols="2" style="max-width: 60px;">
                  <span class="mySchemaShare" @click="clickMySchemaShare(item)">分享</span>
                </v-col>
                <v-col :cols="2" style="max-width: 60px;">
                  <span class="mySchemaDel" @click="clickMySchemaDel(item)">删除</span>
                </v-col>
              </v-row>
              <v-pagination style="margin-top: 28px;margin-bottom:0px !important" class="pagination mb-2" v-model="mySchemaPageNo" :length="mySchemaPageTotal" @input="updateMySchema">
              </v-pagination>
            </v-card>
          </v-col>
          <!-- 分享配置列表 -->
          <v-col style="margin: 4px 4px" :cols="isMobile?12:''">
            <v-card class="mx-auto" v-loading="loadingShareSchema" element-loading-spinner="el-icon-loading">
              <v-row class="schemaTitle">
                <h2>社区分享的配置：</h2>
              </v-row>
              <v-row class="shareSchema">
                <v-col class="orderWrapper">
                  <span class="orderSpan" @click="clickOrder('REF')">按引用次数排序{{ refOrderChar }}</span>
                  <span class="orderSpan" @click="clickOrder('DATE')">按时间排序{{ dateOrderChar }}</span>
                </v-col>
              </v-row>
              <v-row class="shareSchema" v-for="(item, index) in shareSchemaList" :key="index">
                <v-col>
                  <p class="shareSchemaUser">{{item.userName}}</p>
                </v-col>
                <v-col :cols="5">
                  <p class="shareSchemaName">{{item.name}}</p>
                </v-col>
                <v-col>
                  <p class="shareSchemaDate">{{item.createDate | date}}</p>
                </v-col>
                <v-col :cols="1">
                  <p class="shareSchemaRef">{{item.refCount}}</p>
                </v-col>
                <v-col :cols="2">
                  <span class="shareSchemaUse" @click="clickShareSchemaUse(item)">引用</span>
                </v-col>
              </v-row>
              <v-pagination style="margin-top: 28px;margin-bottom:0px !important" class="pagination mb-2" v-model="shareSchemaPageNo" :length="shareSchemaPageTotal" @input="updateShareSchema">
              </v-pagination>
            </v-card>
          </v-col>
        </v-row>
      </Transition>

      <!-- 音频混音器 -->
      <v-row class="third-row">
        <v-col v-if="isFilter">
          <v-row no-gutters class="filterRow">
            <template v-for="item in audioFiles">
              <template v-for="(audio, subIndex) in item.bgSounds">
                <v-col :cols="2" style="max-width: 112px" v-if="audio.selected" :key="subIndex">
                  <BgSoundItem :audio="audio" @changeAudioCheckbox="changeAudioCheckbox" @updateVolume="updateVolume" @tryOccupyGroup="tryOccupyGroup" @tryReleaseOccupyGroup="tryReleaseOccupyGroup"></BgSoundItem>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-col>
        <v-col v-else>
          <v-row no-gutters>
            <v-col :cols="1"></v-col>
            <v-col :cols="2">
              <div class="arrow-left" @click="clickArrowLeft()" v-if="!isFilter">
                <el-button icon="el-icon-d-arrow-left" circle></el-button>
              </div>
            </v-col>
            <v-col :cols="6">
              <span class="typeName">{{ this.audioTypePageIndex }}: {{ this.audioTypePageName }}</span>
            </v-col>
            <v-col :cols="2">
              <div class="arrow-right" @click="clickArrowRight()" v-if="!isFilter">
                <el-button icon="el-icon-d-arrow-right" circle></el-button>
              </div>
            </v-col>
            <v-col :cols="1"></v-col>
          </v-row>
          <template v-for="(item, index) in audioFiles">
            <v-row no-gutters :key="index" v-if="index == (audioTypePageIndex-1)" style="justify-content: center;align-items: flex-start;">
              <v-col :cols="2" style="max-width: 112px" v-for="(audio, subIndex) in item.bgSounds" :key="subIndex">
                <BgSoundItem :audio="audio" @changeAudioCheckbox="changeAudioCheckbox" @updateVolume="updateVolume" @tryOccupyGroup="tryOccupyGroup" @tryReleaseOccupyGroup="tryReleaseOccupyGroup"></BgSoundItem>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-card>
  </div>
</v-dialog>
</template>

<script>
import BgSoundItem from "../BgSoundItem";
import "../../assets/css/iconify.css";
import loading from 'vue-loading';
import {
  queryBgSounds,
  addBgSoundSchema,
  shareBgSoundSchema,
  refShareBgSoundSchema,
  queryMyBgSoundSchemas,
  queryShareBgSoundSchemasByRef,
  queryShareBgSoundSchemasByDate,
  deleteBgSoundSchema,
} from "../../api";
export default {
  components: {
    loading,
    BgSoundItem,
  },
  inject: ['reload'], // 接收注入的数据（负责刷新路由）
  data: function () {
    return {
      loadingMySchema: false,
      loadingShareSchema: false,
      volume: 50,
      newSchemaText: "",
      mySchemaPageNo: 1,
      mySchemaPageTotal: 1,
      mySchemaList: [],
      searchShareSchemaType: "REF",
      shareSchemaPageNo: 1,
      shareSchemaPageOrder: 'desc',
      shareSchemaPageTotal: 1,
      shareSchemaList: [],
      refOrderChar: "",
      dateOrderChar: "",
      isMixPlaying: false,
      show: false,
      loading: false,
      audioContext: null,
      audioFiles: [],
      audioTypePageName: "",
      audioTypePageNum: 1,
      audioTypePageIndex: 1,
      audioSources: new Map(),
      gainNodes: new Map(), // 保存 GainNode 对象
      audioPlayingGroup: new Map(),
      time: "00:30",
      menu2: null,
      isCountDown: false,
      isFold: true,
      isFilter: false,
    };
  },
  computed: {
    bgSoundFlag: {
      set(value) {
        this.$store.state.bgSoundFlag = value;
      },
      get() {
        return this.$store.state.bgSoundFlag;
      }
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    if (localStorage.getItem("time") != null) {
      this.time = localStorage.getItem("time");
    }
    if (localStorage.getItem("volume") != null) {
      this.volume = localStorage.getItem("volume");
    }
    if (localStorage.getItem("isFilter") != null) {
      this.isFilter = localStorage.getItem("isFilter") == "true";
    }
  },
  methods: {
    clickArrowLeft() {
      this.audioTypePageIndex = this.audioTypePageIndex - 1;
      if (this.audioTypePageIndex < 1) {
        this.audioTypePageIndex = this.audioTypePageNum;
      }
      this.audioTypePageName = this.audioFiles[this.audioTypePageIndex - 1].name;
    },
    clickArrowRight() {
      this.audioTypePageIndex = this.audioTypePageIndex + 1;
      if (this.audioTypePageIndex > this.audioTypePageNum) {
        this.audioTypePageIndex = 1;
      }
      this.audioTypePageName = this.audioFiles[this.audioTypePageIndex - 1].name;
    },
    updateSliderVolume() {
      // console.log("updateSliderVolume")
      this.audioFiles.forEach((item, index) => {
        item.bgSounds.forEach((audio, index) => {
          if (audio.selected && audio.volume > 0.01) {
            this.updateVolume(audio)
          }
        });
      });

      localStorage.setItem("volume", this.volume)
    },
    getVolumeIcon() {
      if (this.volume < 10) {
        return "gravity-ui--volume-off"
      } else if (this.volume < 50) {
        return "gravity-ui--volume-low"
      } else {
        return "gravity-ui--volume"
      }
    },
    clickAddSchema() {
      if (this.newSchemaText == "" || this.newSchemaText == null) {
        this.$notify({
          message: "名称不能为空，请填写名称",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        return;
      }

      if (this.$store.state.userId == null) {
        //未登录
        this.$notify({
          message: "请先登录，登录后才可保存配置",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        return;
      }

      var postBody = {
        name: this.newSchemaText,
        schema: this.getSelectedAudioFilesListBase64(),
      };
      addBgSoundSchema(postBody).then((res) => {
          if (res.success == true) {
            this.$notify({
              message: "新增背景音乐配置成功！",
              type: "success",
              showClose: false,
              position: "bottom-right",
              duration: 2000,
            });
            this.updateMySchema();
          } else {
            this.$notify({
              message: "新增背景音乐配置失败！",
              type: "error",
              showClose: true,
              position: "bottom-right",
              duration: 0,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            message: "新增背景音乐配置失败！",
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    clickMySchemaUse(item) {
      this.useSchema(item.schema);
    },
    clickShareSchemaUse(item) {
      this.useSchema(item.schema);
      refShareBgSoundSchema({
        id: item.id
      }).then((res) => {
        this.updateShareSchema();
      });
    },
    useSchema(schema) {
      this.stopMix();
      var loadAudioFiles = JSON.parse(decodeURIComponent(escape(window.atob(schema))));
      var tmpAudioMap = new Map();
      loadAudioFiles.forEach((audio, index) => {
        tmpAudioMap.set(audio.id, audio);
      });

      this.audioFiles.forEach((item, index) => {
        item.bgSounds.forEach((audio, index) => {
          if (tmpAudioMap.has(audio.id)) {
            // 匹配到了
            var tmpAudio = tmpAudioMap.get(audio.id);
            audio.volume = tmpAudio.volume;
            audio.frequency = tmpAudio.frequency;
            audio.volumeRange = tmpAudio.volumeRange;
            audio.timePeriodRange = tmpAudio.timePeriodRange;
            audio.selected = tmpAudio.selected;
            audio.group = tmpAudio.group;
            audio.isMatch = true;
            audio.isMute = false;
            audio.isPlaying = false;
            audio.isGroupOccupied = false;
            audio.downloadState = 'OK';
          } else {
            audio.selected = false;
            audio.group = "";
            audio.isMatch = true;
            audio.isMute = false;
            audio.isPlaying = false;
            audio.isGroupOccupied = false;
            audio.downloadState = 'OK';
          }
        });
      });
    },
    clickMySchemaShare(item) {
      shareBgSoundSchema({
          id: item.id
        }).then((res) => {
          if (res.success == true) {
            this.$notify({
              message: "分享背景音乐配置成功！",
              type: "success",
              showClose: false,
              position: "bottom-right",
              duration: 2000,
            });
            this.updateShareSchema();
          } else {
            this.$notify({
              message: res.message,
              type: "warning",
              showClose: true,
              position: "bottom-right",
              duration: 0,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "warning",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    clickMySchemaDel(item) {
      deleteBgSoundSchema({
          id: item.id
        }).then((res) => {
          if (res.success == true) {
            this.$notify({
              message: "删除背景音乐配置成功！",
              type: "success",
              showClose: false,
              position: "bottom-right",
              duration: 2000,
            });
            this.updateMySchema();
            this.updateShareSchema();
          } else {
            this.$notify({
              message: "删除背景音乐配置失败！",
              type: "error",
              showClose: true,
              position: "bottom-right",
              duration: 0,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            message: "删除背景音乐配置失败！",
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });;
    },
    updateMySchema() {
      this.loadingMySchema = true;
      queryMyBgSoundSchemas({
        pageNo: this.mySchemaPageNo,
      }).then((res) => {
        this.mySchemaList = res.data.records;
        this.mySchemaPageTotal = res.data.pages;
        this.loadingMySchema = false;
      });
    },
    clickOrder(type) {
      if (type == "REF") {
        this.dateOrderChar = ""
        if (this.searchShareSchemaType != "REF") {
          this.refOrderChar = "↑"
          this.shareSchemaPageOrder = "desc"
        } else {
          if (this.shareSchemaPageOrder == "asc") {
            this.refOrderChar = "↑"
            this.shareSchemaPageOrder = "desc"
          } else {
            this.refOrderChar = "↓"
            this.shareSchemaPageOrder = "asc"
          }
        }
      }
      if (type == "DATE") {
        this.refOrderChar = ""
        if (this.searchShareSchemaType != "DATE") {
          this.dateOrderChar = "↑"
          this.shareSchemaPageOrder = "desc"
        } else {
          if (this.shareSchemaPageOrder == "asc") {
            this.dateOrderChar = "↑"
            this.shareSchemaPageOrder = "desc"
          } else {
            this.dateOrderChar = "↓"
            this.shareSchemaPageOrder = "asc"
          }
        }
      }
      this.searchShareSchemaType = type;
      this.updateShareSchema();
    },
    updateShareSchema() {
      this.loadingShareSchema = true;
      // console.log("updateShareSchema")
      if (this.searchShareSchemaType == "REF") {
        // console.log("updateShareSchema REF")
        queryShareBgSoundSchemasByRef({
          pageNo: this.shareSchemaPageNo,
          order: this.shareSchemaPageOrder,
        }).then((res) => {
          this.loadingShareSchema = false;
          this.shareSchemaList = res.data.records;
          this.shareSchemaPageTotal = res.data.pages;
        });
      } else if (this.searchShareSchemaType == "DATE") {
        // console.log("updateShareSchema DATE")
        queryShareBgSoundSchemasByDate({
          pageNo: this.shareSchemaPageNo,
          order: this.shareSchemaPageOrder,
        }).then((res) => {
          this.loadingShareSchema = false;
          this.shareSchemaList = res.data.records;
          this.shareSchemaPageTotal = res.data.pages;
        });
      }
    },
    transTimeToCountDown(time) {
      var a = time.split(':'); // split it at the colons
      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
      // console.log(time);
      // console.log(seconds);
      return seconds * 1000;
    },
    clickPlay() {
      this.$store.state.isPlayBgSound = !this.$store.state.isPlayBgSound;
    },
    getBgSoundsAndLoadCache() {
      this.loading = true;
      queryBgSounds({})
        .then((res) => {
          this.audioFiles = res.data;
          this.audioTypePageNum = this.audioFiles.length;
          this.audioTypePageName = this.audioFiles[this.audioTypePageIndex - 1].name;
          if (localStorage.getItem("schema") != null) {
            this.useSchema(localStorage.getItem("schema"))
          }
          this.initializeAudioContext();
          this.loading = false;
        })
        .catch((err) => {});
    },
    getBgSounds() {
      this.loading = true;
      queryBgSounds({})
        .then((res) => {
          this.audioFiles = res.data;
          this.audioTypePageNum = this.audioFiles.length;
          this.initializeAudioContext();
          this.loading = false;
        })
        .catch((err) => {});
    },
    changeAudioCheckbox(audio) {
      if (this.isMixPlaying) {
        if (audio.selected) {
          if (!this.audioSources.has(audio.id)) {
            this.tryOccupyGroup(audio);
            if (!audio.isGroupOccupied) {
              audio.volume = 0;
            }
            this.loadAndPlayAudio(audio);
            localStorage.setItem("schema", this.getSelectedAudioFilesListBase64())
          }
        } else {
          if (this.audioSources.has(audio.id)) {
            audio.startTime = this.audioContext.currentTime; // 记录当前播放时间
            audio.isPlaying = false; // 设置为未播放状态
            this.tryReleaseOccupyGroup(audio);
            var source = this.audioSources.get(audio.id);
            source.stop();
            source.buffer = null;
            this.audioSources.delete(audio.id)
            localStorage.setItem("schema", this.getSelectedAudioFilesListBase64())
          }
        }
      }
    },
    initializeAudioContext() {
      if (!this.audioContext) {
        this.audioContext = new(window.AudioContext || window.webkitAudioContext)();
      }
    },
    playMix() {
      // console.log("playMix: " + this.isMixPlaying)
      if (this.isMixPlaying) {
        return;
      }
      this.isMixPlaying = true;
      this.initializeAudioContext();
      this.audioFiles.forEach((item, index) => {
        item.bgSounds.forEach((audio, index) => {
          if (audio.selected) {
            this.tryOccupyGroup(audio);
            if (!audio.isGroupOccupied) {
              audio.volume = 0;
            }
            this.loadAndPlayAudio(audio);
          }
        });
      });

      localStorage.setItem("schema", this.getSelectedAudioFilesListBase64())
    },
    getSelectedAudioFilesListBase64() {
      var tmpSelectedAudioFiles = [];
      this.audioFiles.forEach((item, index) => {
        item.bgSounds.forEach((audio, index) => {
          if (audio.selected) {
            tmpSelectedAudioFiles.push(audio)
          }
        });
      });
      return window.btoa(unescape(encodeURIComponent(JSON.stringify(tmpSelectedAudioFiles))));
    },
    stopMix() {
      this.$store.state.isPlayBgSound = false;
      // console.log("stopMix")
      if (!this.isMixPlaying) {
        return;
      }
      // 记录每个音频的播放时间
      this.audioFiles.forEach((item, index) => {
        item.bgSounds.forEach((audio, index) => {
          audio.startTime = this.audioContext.currentTime; // 记录当前播放时间
          audio.isPlaying = false; // 设置为未播放状态
          audio.isGroupOccupied = false;
          this.tryReleaseOccupyGroup(audio);
        });
      });
      this.audioSources.forEach((source, key) => {
        source.stop();
        source.buffer = null;
      });
      this.audioSources.clear();
      this.audioPlayingGroup.clear();
      this.isMixPlaying = false;
    },
    emptyMethod() {},
    loadAndPlayAudio(audio) {
      // console.log("loadAndPlayAudio: group " + audio.group + ", id " + audio.id)
      audio.downloadState = 'DOWNLOADING';
      fetch(audio.path)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => {
          audio.downloadState = 'OK';
          this.audioContext.decodeAudioData(arrayBuffer, buffer => {
            const source = this.audioContext.createBufferSource();
            const gainNode = this.audioContext.createGain();

            gainNode.gain.setValueAtTime(audio.volume * this.volume / 100, this.audioContext.currentTime);
            source.buffer = buffer;
            source.connect(gainNode);
            gainNode.connect(this.audioContext.destination);
            source.loop = true;

            // 设置播放时间
            source.start(0, audio.startTime);
            this.audioSources.set(audio.id, source);
            this.gainNodes.set(audio.id, gainNode);
            audio.isPlaying = true; // 设置为播放状态

            // 监听音频停止事件
            source.onended = () => {
              audio.isPlaying = false; // 设置为未播放状态
            };
          });
        })
        .catch((err) => {
          audio.downloadState = 'FAILED';
          this.$notify({
            message: "下载音频失败，请稍后重试 [" + audio.name + "]",
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
        });
    },
    updateVolume(audio) {
      // console.log(audio.id + ": " + audio.volume);
      if (this.gainNodes.has(audio.id)) {
        this.gainNodes.get(audio.id).gain.setValueAtTime(audio.volume * this.volume / 100, this.audioContext.currentTime + 1);
      }
    },
    tryOccupyGroup(audio) {
      if (Number(audio.group) == 0 || isNaN(Number(audio.group))) {
        // 对于没有分组的音频，默认设置isGroupOccupied为true
        // console.log("Group None, " + audio.id)
        audio.isGroupOccupied = true;
        return;
      }
      if (audio.isGroupOccupied) {
        // console.log("Group Occupied, " + audio.id)
        // 该音频已占用了分组，继续占用退出
        return;
      }
      if (this.audioPlayingGroup.has(Number(audio.group))) {
        // console.log("Group " + audio.group + " is being used, skip " + audio.id)
        audio.isGroupOccupied = false;
        // 该音频所在分组已经被占用，退出
      } else {
        // console.log("Occupy Group " + audio.group + ": " + audio.id)
        this.audioPlayingGroup.set(Number(audio.group), audio.id)
        audio.isGroupOccupied = true
      }
    },
    tryReleaseOccupyGroup(audio) {
      if (Number(audio.group) == 0 || isNaN(Number(audio.group))) {
        // 对于没有分组的音频，默认设置isGroupOccupied为true
        audio.isGroupOccupied = false;
        return;
      }
      if (audio.isGroupOccupied) {
        if (this.audioPlayingGroup.has(Number(audio.group))) {
          if (this.audioPlayingGroup.get(Number(audio.group)) == audio.id) {
            this.audioPlayingGroup.delete(Number(audio.group))
          }
          audio.isGroupOccupied = false
        }
      }
    },
    clickTimer() {
      this.isCountDown = !this.isCountDown;
    },
    clickFold() {
      this.isFold = !this.isFold;
      if (!this.isFold) {
        if (this.$store.state.userId == null) {
          //未登录
          this.$notify({
            message: "请先登录，登录后才可管理“我的配置”",
            type: "warning",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
          this.isFold = false;
        } else {
          this.updateMySchema();
        }
        this.updateShareSchema();
      }
    },
    handleCountdownEnd() {
      this.$store.state.isPlayBgSound = false;
      this.isCountDown = false;
    },
    reset() {
      this.stopMix();
      this.getBgSounds();
    },
    clickFilter() {
      this.isFilter = !this.isFilter;
      localStorage.setItem("isFilter", this.isFilter);
    },
    clickVolume() {
      if (this.volume >= 10) {
        this.volume = 0;
      } else {
        this.volume = 50;
      }
      this.updateSliderVolume();
    },
    pickTime() {
      localStorage.setItem("time", this.time);
    }
  },
  watch: {
    "$store.state.bgSoundFlag": {
      deep: true, 
      handler: function (newValue) {
        console.log("watch: " + newValue);
        if(newValue && !this.isMixPlaying){
          this.getBgSoundsAndLoadCache();
        }
      }
    },
    "$store.state.isPlayBgSound": {
      deep: true,
      handler: function (newValue) {
        // console.log("watch: " + newValue);
        if (newValue) {
          this.playMix();
        } else {
          this.stopMix();
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bg-sound-container {
  border-radius: 4px;
  /* padding: 20px; */
  margin-top: 0px !important;
}

#control {
  position: relative;
  width: 40px;
  height: 40px;
  cursor: url("~@/assets/images/pointer.png"), default;

  .border {
    width: 100%;
    height: 100%;
    border: 4px solid #409EFF;
    border-radius: 20px;
  }

  &.is--playing .border {
    border-top: none;
    border-bottom: none;
    animation: spin 3.0s linear infinite;
  }

  .play {
    position: absolute;
    top: 9px;
    left: 16px;
    box-sizing: border-box;
    height: 18px;
    width: 25px;

    border-color: transparent transparent transparent #409EFF;
    transition: 100ms all ease;
    will-change: border-width;
    cursor: url("~@/assets/images/pointer.png"), default;

    border-style: double;
    border-width: 0px 0 0px 10px;
    transform: translate(-1px, 1px);
  }

  &.is--playing .play {
    border-style: solid;
    border-width: 10px 0 10px 13px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (min-width: 760px) {
  .filterRow{
    min-height: 200px;justify-content: left;align-items: flex-start;
  }
  .first-row {
    background-color: hsl(0, 0%, 28%);
    padding: 20px 10px 0px;
  }

  .second-row {
    padding: 0px 10px;
    margin: 0px !important;
    background: linear-gradient(0deg, hsl(198.95deg 76% 95.1%), #000000, hsl(0, 0%, 28%));
  }

  .third-row {
    background-color: hsl(198.95deg 76% 95.1%);
    padding: 10px 10px;
    margin: 0px !important;
    min-height: 540px;
    transform: scale(1)
  }
}

@media (max-width: 759px) {
  .filterRow{
    min-height: 200px;justify-content: center;align-items: flex-start;
  }
  .first-row {
    background-color: hsl(0, 0%, 28%);
    padding: 20px 10px 0px;
  }

  .second-row {
    padding: 0px 0px;
    margin: 0px !important;
    background: linear-gradient(0deg, hsl(198.95deg 76% 95.1%), #000000, hsl(0, 0%, 28%));
  }

  .third-row {
    background-color: hsl(198.95deg 76% 95.1%);
    padding: 10px 0px;
    margin: 0px !important;
    min-height: 540px;
    transform: scale(1)
  }
}

#clock {
  font-family: 'Share Tech Mono', monospace;
  color: #ffffff;
  text-align: left;
  position: relative;
  /* transform: translate(-50%, -50%); */
  color: #daf6ff;
  text-shadow: 0 0 5px rgba(10, 175, 230, 1), 0 0 5px rgba(10, 175, 230, 0);
  top: 4px;

  .time {
    letter-spacing: 0.05em;
    font-size: 20px;
    /* padding: 5px 0; */
    margin-bottom: 0px !important;
  }

}

.volumeBtn {
  width: 42px;
  height: 42px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.resetBtn {
  width: 42px;
  height: 42px;

  &:active {
    animation: none;
    transform: rotate(-360deg);
    transition: 0.2s ease;
  }

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.filterBtn {
  width: 42px;
  height: 42px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.foldBtn {
  width: 42px;
  height: 42px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.timerBtn {
  width: 42px;
  height: 42px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.time-picker-div {
  .v-text-field {
    padding-top: 0px;
    margin-top: 8px;
  }

  .v-text-field :deep(.v-label) {
    color: #bcbcbc !important
  }

  .v-text-field :deep(input) {
    font-size: 16px;
    color: #fff !important
  }

  :deep(.v-text-field__details) {
    display: none;
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 100ms;
}

.addSchemaText {
  padding: 4px;
  margin-left: 8px;
  margin-top: 11px;
}

.shareSchema {
  padding: 2px 8px;
  color: #000;
  //   background-color: #daf6ff;
  border-bottom: 1px dashed #00000033;

  .orderWrapper {
    text-align: right;
    padding-right: 20px;
    margin-right: 10px;
  }

  .orderSpan {
    font-size: small;
    margin: 0px 8px;
    border-bottom: 1px dashed #333333aa;

    &:hover {
      color: #2793ffe3;
      cursor: url("~@/assets/images/pointer.png"), default;
    }
  }

  .shareSchemaUser {
    padding: 0px 4px;
    margin-left: 8px;
  }

  .shareSchemaName {
    padding: 0px 4px;
  }

  .shareSchemaUse {
    width: 50px;
    height: 24px;
    display: inline-block;
    padding: 0px 4px 4px;
    font-size: 16px;
    cursor: url("~@/assets/images/pointer.png"), default;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #40a0ffe3;
    border: none;
    border-radius: 4px;
    box-shadow: 0 4px #777777aa;

    &:hover {
      background-color: #2793ffe3;
      cursor: url("~@/assets/images/pointer.png"), default;
    }

    &:active {
      background-color: #5daeffe3;
      box-shadow: 0 2px #666666aa;
      transform: translateY(4px);
    }
  }
}

.schemaTitle {
  margin-left: 12px;
  padding-top: 12px;
}

.mySchema {
  padding: 2px 8px;
  color: #000;
  //   background-color: #daf6ff;
  border-bottom: 1px dashed #00000033;

  .mySchemaUser {
    padding: 4px;
  }

  .mySchemaName {
    padding: 0px 4px;
    margin-left: 8px;
  }

  .mySchemaShare,
  .mySchemaUse {
    width: 50px;
    height: 24px;
    display: inline-block;
    padding: 0px 4px 4px;
    font-size: 16px;
    cursor: url("~@/assets/images/pointer.png"), default;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #40a0ffe3;
    border: none;
    border-radius: 4px;
    box-shadow: 0 4px #777777aa;

    &:hover {
      background-color: #2793ffe3;
      cursor: url("~@/assets/images/pointer.png"), default;
    }

    &:active {
      background-color: #5daeffe3;
      box-shadow: 0 2px #666666aa;
      transform: translateY(4px);
    }
  }

  .mySchemaDel {
    width: 50px;
    height: 24px;
    display: inline-block;
    padding: 0px 4px 4px;
    font-size: 16px;
    cursor: url("~@/assets/images/pointer.png"), default;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #ff40409a;
    border: none;
    border-radius: 4px;
    box-shadow: 0 4px #777777aa;

    &:hover {
      background-color: #fb2d2d9a;
      cursor: url("~@/assets/images/pointer.png"), default;
    }

    &:active {
      background-color: #ff60609a;
      box-shadow: 0 2px #666666aa;
      transform: translateY(4px);
    }
  }
}

// .filterBtn {
//   z-index: 1;
//   display: inline-block;
//   position: absolute;
//   right: 64px;
//   margin-top: 0px;
// }

// .resetBtn {
//   z-index: 1;
//   display: inline-block;
//   position: absolute;
//   right: 20px;
//   margin-top: 0px;
// }
.volume-slider {
  margin-top: 5px;

  :deep(.v-slider--horizontal) .v-slider__track-container {
    height: 4px;
    ;
  }
}

.arrow-left {
  height: 60px;
  margin: auto;
  transition: transform 0.1s;
  width: 50px;
  z-index: 1;
  position: relative;
  vertical-align: middle;
  line-height: 60px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.arrow-right {
  margin: auto;
  height: 60px;
  transition: transform 0.1s;
  width: 50px;
  z-index: 1;
  position: relative;
  vertical-align: middle;
  line-height: 60px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.close-btn {
  position: absolute;
  right: 4px;
  top: 2px;
  display: inline-block;
  width: 32px;
  height: 32px;

  &:hover {
    cursor: url("~@/assets/images/pointer.png"), default;
  }
}

.typeName {
  font-size: 32px;
  text-align: center;
  /* margin: auto; */
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  vertical-align: middle;
  line-height: 60px;
  /* height: 37px; */
  margin-top: 2px;
  font-weight: 600;
}
</style>
